import { render, staticRenderFns } from "./CiVideoIndicator.vue?vue&type=template&id=72ea808a&"
import script from "./CiVideoIndicator.vue?vue&type=script&lang=js&"
export * from "./CiVideoIndicator.vue?vue&type=script&lang=js&"
import style0 from "./CiVideoIndicator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports